import React from 'react'
import { observer } from 'mobx-react'

const BankCodeTooltip = () => {
  return (
    <div>
      A SWIFT code is an international bank code that identifies particular
      banks worldwide. It's also known as a Bank Identifier Code (BIC). The
      codes are usually 8 or 11 characters long. Routing number is 9 characters
      long number used to identify financial institution in a transaction.
    </div>
  )
}

export default observer(BankCodeTooltip)
